<template>
  <div class="main">
    <van-sticky>
      <van-tabs v-model="orderactive" sticky swipeable @click="toggle" color="#409EFF">
        <van-tab title="进行中">
        </van-tab>
        <van-tab title="已完成">
        </van-tab>
        <van-tab title="全部订单">
        </van-tab>
      </van-tabs>
    </van-sticky>

    <div class="content" v-if="orders.length > 0">
      <div style="display: flex;width: 100%;flex-direction: column;justify-content: center;align-items: center"
           v-for="item in orders" v-bind:key="item.id">
        <div class="list" :class="{expired:item.status == '4'}" v-if="item.companyid == '0000'">
          <span style="font-size: 2.5rem;margin-top: 1rem;color: #DC6E1C;">
            <span style="color: #409EFF;">{{ item.packagename || item.packageid }}</span><span style="float: right;">
            <span style="padding: 0.5rem 2rem;color: #66B1FF;" v-if="item.oneself == '1'">本人</span>
            <span style="padding: 0.5rem 2rem;color: #FFC972;" v-if="item.oneself == '0'">亲属</span>
          </span>
          <van-divider/>
          </span>
          <span v-if="getsingleShowMoney(item.companyID) && showMoney" style="font-size: 2.2rem;margin-top: 0.5rem;color: #666666;">订单金额：<span
              style="color: #FFAF2D;font-size: 3rem;font-weight: 600;">￥{{ item.amount }}</span></span>
          <span style="font-size: 2.2rem;margin-top: 0.5rem;color: #666666;padding-left: 1em;">体检人：{{
              item.userInfo.name
            }}</span>
          <span style="font-size: 2.2rem;margin-top: 0.5rem;color: #666666;">订单编号：{{ item.bookedno }}</span>
          <span style="font-size: 2.2rem;margin-top: 0.5rem;color: #666666;">下单时间：{{ item.bookeddate }}</span>
          <span style="font-size: 2.2rem;margin-top: 0.5rem;color: #666666;">体检时间：{{ item.checkdate }}</span>
          <span
              style="font-size: 2.2rem;margin-top: 0.5rem;color: #666666;">支付状态：{{
              item.settlement | filterSettlement
            }}</span>
          <span style="margin-top: 1.5rem">
            <van-button
                v-if="VUE_APP_PAY_ENABLE && item.orderSource != '1' && item.settlement=='0' && (item.status == 0 || item.status==1 || (item.status == 1 && item.orderno == null))"
                type="primary" round size="small" style="float:right;margin-left: .5em;"
                @click="pay(item.bookedno,item.amount,item.packagename,true)"
            >立即支付</van-button>
            <van-button
                v-if="VUE_APP_PAY_ENABLE && item.orderSource == '1' && (item.settlement=='0' || item.settlement == '2') && parseFloat(item.selfAmount) > 0"
                type="primary" round size="small" style="float:right;margin-left: .5em;"
                @click="pay(item.serialNo,item.selfAmount,item.packageName,false)"
            >立即支付</van-button>
            <van-button
                v-if="VUE_APP_PAY_ENABLE && item.settlement=='1' && (item.status == 0 || item.status==1)"
                type="danger" round size="small" style="float:right;margin-left: .5em;"
                @click="refundOrder(item)"
                :disabled="refundloading"
            >申请退款</van-button>
            <van-button
                type="info" round size="small" style="float:right;margin-left: .5em;"
                @click="toDetail(item)"
            >查看详情</van-button>
            <van-button
                v-if="item.settlement!='1' && item.status == 0 "
                color="#FFAA44"
                round size="small" style="float:right;margin-left: .5em;"
                @click="toOrderDateUpdate(item.packageid,item.checkdate,item.bookedno,item.timeslot)"
            >更改日期</van-button>
            <van-button
                v-if="item.settlement!='1' && item.status == 0 "
                type="warning" round size="small" style="float:right;margin-left: .5em;"
                @click="delOrder(item.bookedno)"
            >取消预约</van-button>
          </span>
        </div>
        <div style="display: flex;width: 100%;flex-direction: column;justify-content: center;align-items: center"
             v-if="item.companyid !== '0000'">
          <company :item="item"></company>
        </div>
      </div>
    </div>
    <div class="content" v-if="orders.length == 0">
      <van-empty description="没有查询到您的订单">
      </van-empty>
    </div>
    <!--    <van-button type="default" @click="refreshList">-->
    <!--      刷新列表-->
    <!--    </van-button>-->
    <div class="footer">
      <van-tabbar v-model="active" active-color="#409EFF" inactive-color="#000">
        <van-tabbar-item icon="home-o" @click="toHome">首页</van-tabbar-item>
        <!-- 2025-02-26 ZLS 新增模块跳转       -->
        <van-tabbar-item icon="comment-o" :badge="messageCount" @click="toMessage" v-if="messageShow">健康科普</van-tabbar-item>
        <!-- 2024-08-19 ZLS 新增模块跳转       -->
        <van-tabbar-item icon="todo-list-o" :badge="task" @click="toTask">待办任务</van-tabbar-item>
        <van-tabbar-item icon="shopping-cart-o">我的订单</van-tabbar-item>
        <van-tabbar-item icon="user-o" @click="toUserinfo">个人中心</van-tabbar-item>
      </van-tabbar>
    </div>
    <div v-if="payLoading"
         style="display: flex;justify-content: center;align-items: center;z-index: 9999;width: 100%;height: 100%;position: absolute;top: 0;background-color: hsla(0,0%,100%,.9);">
      <van-loading color="#0094ff" text-color="#0094ff" size="24px">正在跳转支付...</van-loading>
    </div>
    <div v-if="payRefreshLoading"
         style="display: flex;justify-content: center;align-items: center;flex-direction: column;z-index: 9999;width: 100%;height: 100%;position: absolute;top: 0;background-color: hsla(0,0%,100%,.9);">
      <van-circle v-model="currentRate" :rate="endRate" :speed="100" :text="currentSecond + `秒`" />
      <div style="font-size: 2em;margin-top: 1em;">后台正在处理...，请稍候</div>
    </div>
    <div v-if="refundloading"
         style="display: flex;justify-content: center;align-items: center;flex-direction: column;z-index: 9999;width: 100%;height: 100%;position: absolute;top: 0;background-color: hsla(0,0%,100%,.9);">
      <van-circle v-model="currentRate" :rate="endRate" :speed="100" :text="currentSecond + `秒`" />
      <div style="font-size: 2em;margin-top: 1em;">退款处理中...，请勿操作！<br/>稍后请在微信消息中查看退款结果</div>
    </div>
  </div>
</template>

<script>
import {getOrders, delOrder, getCompanyBookedList} from '@/api/module/user'
import {getPayStatus, getChargeRefundCount, getWeChatMessageCount} from '@/api/module/index'
import {getConsentFormCount, getMedicalOrders, getPaymentUrlByBookedNo} from "@/api/module";
import {Dialog, Toast} from "vant";
import {encrypt} from "@/assets/utils/cryptoUtil";
import {transactions,refundOrder,queryRefundOrder} from "@/api/module/auth";
import company from "./Company.vue"

export default {
  name: "index",
  components: {
    company
  },
  data() {
    return {
      showMoney: window.g.VUE_APP_SHOW_MONEY,
      VUE_APP_HIDE_MONEY_COMPANYIDS:window.g.VUE_APP_HIDE_MONEY_COMPANYIDS,
      active: window.g.VUE_APP_MESSAGE_NOTIFICATION ? 3 :2,
      orderactive: 0,
      orderList: [],
      orders: [],
      phone: window.g.VUE_APP_PHONE,
      hisChargeOpen: window.g.VUE_APP_HIS_CHARGE_OPEN,
      VUE_APP_ISWECHAT: window.g.VUE_APP_ISWECHAT,
      VUE_APP_PAY_TYPE: window.g.VUE_APP_PAY_TYPE,
      VUE_APP_PAY_ENABLE: window.g.VUE_APP_PAY_ENABLE,
      VUE_APP_OFFLINE_ORDER: window.g.VUE_APP_OFFLINE_ORDER,
      payLoading: false,
      refundloading:false,
      payRefreshLoading:false,
      // 单位订单列表
      companys: [],
      // 订单合并列表
      concat: [],
      task: 0, // 待办任务数量
      timer:null,
      paySerialno:'',
      isOrder:true,//JSAPI 支付是否是预约
      currentSecond:1,//当前秒数
      currentRate: 0,//环形进度起点
      endRate: 6.6,//当前环形进度百分比
      isPastNoonVal:false,
      messageCount: 0, // 消息数量
      messageShow: window.g.VUE_APP_MESSAGE_NOTIFICATION,
      messageInterval: null,// 定时器引用
    };
  },
  filters: {
    filterSettlement(value) {
      switch (value) {
        case '0': {
          return '未付款'
          break;
        }
        case '1': {
          return '已付款'
          break;
        }
        case '2': {
          return '部分结算'
          break;
        }
        default: {
          return ''
        }
      }
    },
    filterDatetime(val){
      return val.substring(0,10)
    }
  },
  created() {
    //清除定时器
    if(!this.timer){
      clearInterval(this.timer)
    }

    if(this.VUE_APP_ISWECHAT == "1"){
      if(sessionStorage.getItem("userinfo") == null){
        this.$router.push({name: 'wechatAuth',query:{pathName:"orders"}})
      }
      else{
        let userinfo = JSON.parse(sessionStorage.getItem("userinfo"));
        this.openid = userinfo.openid
      }
    }
    this.getOrders()
    this.getConsentFormCount()
    this.getWeChatMessageCount()
  },

  methods: {
    test(){
      console.log("父组件方法")
    },
    //计算showMoney的值
    getsingleShowMoney(companyID){
      let singleShowMoney = true
      if(this.showMoney){
        if(Array.isArray(this.VUE_APP_HIDE_MONEY_COMPANYIDS)){
          if(companyID != undefined && this.VUE_APP_HIDE_MONEY_COMPANYIDS.includes(companyID.substring(0,4))){
            singleShowMoney = false
          }
        }
      }
      return singleShowMoney
    },
    filterDisableRefund(item){
      if(!this.isPastNoon(item)){
        return true
      }
      else{
        if(item.disablerefund != "1"){
          return true
        }
        else{
          return false
        }
      }
    },
    /**
     * 返回一个布尔值，true 表示已经过了中午12点，false 表示还没到中午12点
     * @author luotong
     * @date 2025-02-24 17:10
     */
    isPastNoon(item) {
      // 获取当前日期
      let today = new Date();
      today.setHours(0, 0, 0, 0); // 设置时间为当天的00:00:00.000

      // 将给定的日期时间设置为当天的00:00:00.000，以便仅比较日期部分
      let givenDateNormalized = new Date(item.bookeddate);
      givenDateNormalized.setHours(0, 0, 0, 0);

      // 比较两个日期
      if(today > givenDateNormalized){
        return true
      }
      else{
        return false
      }
    },
    //2024-08-19 ZLS  新增获取待办任务的数量
    getConsentFormCount() {
      let loginuser = JSON.parse(localStorage.getItem("loginuser"));
      if (loginuser == null) {
        return
      }
      let param = {
        patientid: loginuser.patientid
      }
      getConsentFormCount(param).then(res => {
        if (res.code == 200 && res.data > 0) {
          this.task = res.data;
        }
      })
    },
    pay(bookedno, amout, packagename,isOrder) {
      this.paySerialno = bookedno
      if(isOrder){
        this.isOrder = true
      }
      else{
        this.isOrder = false
      }
      //跳转支付链接
      if (this.VUE_APP_PAY_TYPE == "0") {
        this.payLoading = true
        this.toPayPage(bookedno)
      }
      //JSAPI调起支付
      else if (this.VUE_APP_PAY_TYPE == "2") {
        this.jsApiPay(amout,packagename,bookedno,isOrder)
      }
      //his收费
      else if (this.hisChargeOpen == "1") {
        Dialog.alert({
          message: "暂未支持，请至体检中心完成支付"
        })
      }
    },
    jsApiPay(amout, packagename,attach) {
      console.log('调用微信JSAPI支付')
      console.log(this.VUE_APP_ISWECHAT)

      if (this.VUE_APP_ISWECHAT == "1") {
        let userinfo = JSON.parse(sessionStorage.getItem("userinfo"));
        this.openid = userinfo.openid
        console.log(this.openid)
        var vm = this
        if (this.openid == undefined || this.openid == '') {
          alert("缺少openid参数，无法完成支付")
          return;
        }
        let params = {
          type: 'jsapi',//支付类型
          openid: this.openid,//公众号id
          total: parseFloat(amout) * 100,//订单金额
          attach:attach,//回调通知原样传递参数
          description: packagename + '体检费',//商品描述信息
        }
        transactions(params).then(res => {
          let data = {
            appId: res.signMap.appId,//公众号id，必传
            nonceStr: res.signMap.nonceStr,//随机串，必传
            timeStamp: res.signMap.timeStamp,//时间戳，必传
            package: "prepay_id=" + res.prepay_id,//必传
            signType: res.signMap.signType,//微信签名方式
            paySign: res.signMap.paySign,//微信签名
          }
          // 下面是解决WeixinJSBridge is not defined 报错的方法
          if (typeof WeixinJSBridge === 'undefined') { // 微信浏览器内置对象。参考微信官方文档
            if (document.addEventListener) {
              setTimeout(function () {
                document.addEventListener('WeixinJSBridgeReady', vm.onBridgeReady(data), false)
              }, 1000)

            } else if (document.attachEvent) {
              setTimeout(function () {
                document.attachEvent('WeixinJSBridgeReady', vm.onBridgeReady(data))
                document.attachEvent('onWeixinJSBridgeReady', vm.onBridgeReady(data))
              }, 1000)
            }
          } else {
            console.log('准备调用微信支付')
            setTimeout(function () {
              vm.onBridgeReady(data)
            }, 1000)
          }
        }).catch(err => {
          Dialog.alert({
            message: "统一下单返回出错：" + err
          }).then(() => {

          })
        })
      } else {
        Dialog.alert({
          message: "openid不存在，无法完成支付"
        })
      }
    },
    onBridgeReady(data) {
      console.log('调用微信支付WeixinJSBridge')
      console.log('参数', data)
      let vm = this
      WeixinJSBridge.invoke(
          'getBrandWCPayRequest', { // 下面参数内容都是后台返回的
            'appId': data.appId, // 公众号名称，由商户传入
            'timeStamp': data.timeStamp, // 时间戳
            'nonceStr': data.nonceStr, // 随机串
            'package': data.package, // 预支付id
            'signType': data.signType, // 微信签名方式
            'paySign': data.paySign // 微信签名
          },
          function (res) {
            // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            if (res.err_msg === 'get_brand_wcpay_request:ok') {
              vm.currentSecond = 1
              vm.endRate = 6.6
              vm.payRefreshLoading = true
              vm.timer = setInterval(function (){
                setTimeout(()=>{
                  vm.payStatusRefresh()
                },0)
              },1000)
            } else {
              Dialog.alert({
                message: '支付失败' + res.err_msg
              }).then(() => {

              })
            }
          }
      )
    },
    //刷新支付状态
    payStatusRefresh(){
      let _this = this
      //定时器效果
      _this.currentSecond++
      _this.endRate = _this.endRate + 6.6
      if(_this.currentSecond > 15){
        clearInterval(_this.timer)
        _this.payRefreshLoading = false
      }
      let params = {
        bookedno:encrypt(_this.paySerialno),
        isorder:_this.isOrder
      }
      getPayStatus(params).then(res => {
        if(res.data == "1"){
          _this.payRefreshLoading = false
          clearInterval(_this.timer)
          //支付成功后更新订单状态
          _this.$nextTick(()=>{
            _this.getOrders()
          })
        }
      })
    },
    //刷新退款状态
    refundStatusRefresh(chargeno){
      let _this = this
      //定时器效果
      _this.currentSecond++
      _this.endRate = _this.endRate + 6.6
      if(_this.currentSecond > 15){
        clearInterval(_this.timer)
        _this.refundloading = false
      }
      let params = {
        chargeno:chargeno,
      }
      getChargeRefundCount(params).then(res => {
        if(res.data > 0){
          _this.refundloading = false
          clearInterval(_this.timer)
          //退费成功后刷新页面
          _this.$nextTick(()=>{
            _this.getOrders()
          })
        }
      })
    },
    //跳转到支付页面
    toPayPage(bookedno) {
      let params = {
        bookedno: encrypt(bookedno)
      }
      getPaymentUrlByBookedNo(params).then(res => {
        if (res.code == 200) {
          window.location.href = res.data
        } else {
          this.payLoading = false
          Toast.fail("支付失败" + res.data)
        }
      })
    },
    //申请退款
    refundOrder(item){
      let _this = this
      if(_this.filterDisableRefund(item)){
        _this.refundloading = true
        _this.currentSecond = 1
        _this.endRate = 6.6
        let params = {
          transactionId: item.chargeCustom.transactionno,//微信订单号
          refundFee: parseFloat(item.chargeCustom.amount) * 100,//退款金额
          outRefundNo: item.chargeCustom.chargeno,//退款单号
        }
        refundOrder(params).then(res => {
          //通过轮询获取退款状态（从体检系统去查询）
          _this.timer = setInterval(function (){
            setTimeout(()=>{
              _this.refundStatusRefresh(item.chargeCustom.chargeno)
            },0)
          },3000)
        })
      }
      else{
        Dialog.alert({
          title: '提示',
          message: '退费超过时限，请至现场联系工作人员！',
          theme: 'round-button',
        }).then(() => {
          // on close
        });
      }
    },
    //查询单笔退款信息
    queryRefundOrder(refundNo){
      let _this = this
      let params = {
        refundNo: refundNo,
      }
      queryRefundOrder(params).then(res => {
        /**
         * 款到银行发现用户的卡作废或者冻结了，导致原路退款银行卡失败，可前往商户平台-交易中心，手动处理此笔退款。
         * 枚举值：
         * SUCCESS：退款成功
         * CLOSED：退款关闭
         * PROCESSING：退款处理中
         * ABNORMAL：退款异常
         */
        switch (res.status)
        {
          case "SUCCESS":{
            _this.refundloading = false
            clearInterval(_this.timer)
            Toast("退款成功")
            location.reload()
            break
          }
          case "CLOSED": {
            _this.refundloading = false
            clearInterval(_this.timer)
            Toast.fail("退款关闭")
            break
          }
          case "ABNORMAL": {
            _this.refundloading = false
            clearInterval(_this.timer)
            Toast.fail("退款异常")
            break
          }
          default:{

          }
        }
      })
    },
    //切换
    toggle() {
      if (this.orderactive == '0') {
        //查询进行中的
        this.orders = this.concat.filter(item => {
          return (item.status == "9" || item.status == "0" || item.status == "1")
        })
      } else if (this.orderactive == '1') {
        //查询已完成的
        this.orders = this.concat.filter(item => {
          return item.status == "2"
        })
      } else if (this.orderactive == '2') {
        //查询所有的
        this.orders = this.concat
      }
    },
    getOrders() {
      let loginuser = JSON.parse(localStorage.getItem("loginuser"));
      //手机号码
      let param = {
        patientid: loginuser.patientid
      }
      getOrders(param).then(res => {
        if (res.code == 200) {
          if (res.data == -1) {
            Dialog({
              message: res.msg + ',请立即联系体检中心处理，电话：' + this.phone,
              theme: 'round-button',
            });
          } else {
            this.$nextTick(()=>{
              this.orderList = res.data
              // 20240816 ZLS
              this.getList()
            })
          }
        }
      }).catch(err => {
        this.getList()
      })
    },
    getNow() {
      let char = "-";
      let nowDate = new Date();
      let day = nowDate.getDate();
      let month = nowDate.getMonth() + 1;//注意月份需要+1
      let year = nowDate.getFullYear();
      //补全0，并拼接
      return year + char + this.completeDate(month) + char + this.completeDate(day);
    },
    //补全0
    completeDate(value) {
      return value < 10 ? "0" + value : value;
    },
    toHome() {
      this.$router.push({name: 'home'})
    }
    ,
    toUserinfo() {
      this.$router.push({name: 'userinfo'})
    },
    toTask() {
      this.$router.push({name: 'letterConsent'})
    }
    ,
    toReport() {
      this.$router.push({name: 'report'})
    }
    ,
    toDetail(item) {
      this.$router.push({
        name: 'orderDetail',
        query: {bookedno: item.bookedno, settlement: item.settlement, status: item.status, orderno: item.orderno,companyid:item.companyID}
      })
    },
    delOrder(bookedno) {
      //取消确认
      Dialog.confirm({
        title: '取消确认',
        message: '确认取消预约吗？'
      }).then(() => {
        // on confirm
        let param = {
          bookedno: bookedno
        }
        delOrder(param).then(res => {
          if (res.code == 200) {
            Toast(res.msg)
            this.$nextTick(()=>{
              this.getOrders()
            })
          }
        })
      }).catch(() => {
        // on cancel
      })
    },
    toOrderDateUpdate(packageid, checkdate, bookedno, timeslot) {
      console.log(packageid, " | ", checkdate, " | ", bookedno, " | ", timeslot)
      this.$router.push({
        name: 'orderDateUpdate',
        query: {packageId: packageid, bookedNo: bookedno, checkDate: checkdate, timeSlot: timeslot}
      })
    },
    getList() {
      let user = JSON.parse(localStorage.getItem("loginuser"))
      let param = {
        name: user.name,
        patientId: user.patientid,
        cardId: user.cardid,
        phone: user.phone
      }
      getCompanyBookedList(param).then(res => {
        this.noDataShow = true
        if (res.code == 200) {
          this.companys = res.data
          // 20240816 ZLS 合并单位订单列表和个人订单列表 后按预约时间排序
          if (res.data.length > 0 && this.orderList.length > 0) {
            this.concat = this.sequencingByMerging(this.companys, this.orderList)
          }
          if (res.data.length === 0 && this.orderList.length > 0) {
            this.concat = this.orderList
          }
          if (res.data.length > 0 && this.orderList.length === 0) {
            this.concat = this.companys
          }
          if (res.data.length === 0 && this.orderList.length === 0) {
            this.concat = []
          }

          if(this.VUE_APP_OFFLINE_ORDER){
            this.getMedicalList()
          }
          else {
            this.toggle()
          }
        } else {
          Toast.fail(res.msg);
        }
      })
    },
    getMedicalList() {
      let user = JSON.parse(localStorage.getItem("loginuser"))
      let param = {
        patientid: user.patientid,
      }
      getMedicalOrders(param).then(res => {
        this.noDataShow = true
        if (res.code == 200) {
          let concatList = []
          concatList = this.concat.concat(res.data)
          console.log(concatList)
          this.concat = concatList
          this.toggle()
        } else {
          Toast.fail(res.msg);
        }
      })
    },
    // 合并订单列表后按时间排序
    sequencingByMerging(companys, orderList) {
      let concatList = companys.concat(orderList)
      concatList.forEach((item) => {
        if (!item.bookeddate) {
          item.bookeddate = item.bookedDate
        }
        if (!item.companyid) {
          item.companyid = item.companyID
        }
      })

      return concatList.sort(function (a, b) {
        return  new Date(b.bookeddate).getTime() - new Date(a.bookeddate).getTime()
      })
    },
    toMessage() {
      this.$router.push({name: 'message'})
    },
    getWeChatMessageCount() {
      if (!this.messageShow) {
        return;
      }
      let loginuser = JSON.parse(localStorage.getItem("loginuser"));

      if (!this.messageInterval){
        getWeChatMessageCount({patientID: loginuser.patientid}).then(res => {
          const messageCount = localStorage.getItem("messageCount");
          this.messageCount = res.data - messageCount
        })
      }
    }
  },
  beforeDestroy() { // 或者使用 unmounted
    if (this.messageInterval) {
      clearInterval(this.messageInterval);
    }
  }
}
</script>

<style scoped>
.main {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  background: #F5F5F5;
}

.list {
  width: 90%;
  background: #fff;
  border-radius: 1rem;
  box-shadow: 0 0 5px #C6E2FF;
  display: flex;
  flex-flow: column;
  margin-top: 1.5rem;
  padding: 2rem;
}

.content {
  width: 100%;
  display: flex;
  flex-flow: column;
  align-items: center;
  padding-bottom: 16rem;
}
.expired{
  background-image: url("~@/assets/images/expired.png");
  background-position: 95% 35%;
  background-repeat: no-repeat;
  background-size: 15% auto;
}
</style>
